/* Blonyx carousel dots: animated dot pagination for native horizontal scrollers (mobile).
   Markup: put <div class="bx-dots" data-bx-dots hidden></div> right after the scrolling track.
   One dot per visible card; the dot nearest the snap position is current. Tapping a dot scrolls to its card.
   Only listens to scroll on the track itself (passive) and never touches page scrolling. */
(() => {
  if (window.__bxDots) return;
  window.__bxDots = true;
  const cardsOf = track => [...track.children].filter(card => card.getClientRects().length);
  const offset = (track, card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
  const sync = dots => {
    const track = dots.previousElementSibling;
    if (!track) return;
    const cards = cardsOf(track);
    const overflows = track.scrollWidth > track.clientWidth + 2;
    dots.hidden = !overflows || cards.length < 2;
    if (dots.hidden) return;
    if (dots.childElementCount !== cards.length) {
      dots.innerHTML = cards.map((_, i) => `<button type="button" class="bx-dot" aria-label="Show item ${i + 1} of ${cards.length}"></button>`).join('');
    }
    const max = track.scrollWidth - track.clientWidth;
    let active = 0;
    let best = Infinity;
    cards.forEach((card, i) => { const d = Math.abs(offset(track, card)); if (d < best) { best = d; active = i; } });
    if (track.scrollLeft >= max - 2) active = cards.length - 1;
    [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
  };
  const init = dots => {
    if (dots.dataset.bxDotsReady) return sync(dots);
    const track = dots.previousElementSibling;
    if (!track) return;
    dots.dataset.bxDotsReady = 'true';
    let frame = 0;
    let settle = 0;
    // sync on the next frame while scrolling, and once more after the snap settles
    const queue = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => sync(dots));
      clearTimeout(settle);
      settle = setTimeout(() => sync(dots), 150);
    };
    track.addEventListener('scroll', queue, {passive: true});
    track.addEventListener('scrollend', queue, {passive: true});
    if (window.ResizeObserver) new ResizeObserver(queue).observe(track);
    if (window.MutationObserver) new MutationObserver(queue).observe(track, {attributes: true, attributeFilter: ['hidden'], subtree: true, childList: true});
    dots.addEventListener('click', event => {
      const dot = event.target.closest('.bx-dot');
      if (!dot) return;
      const card = cardsOf(track)[[...dots.children].indexOf(dot)];
      if (card) track.scrollBy({left: offset(track, card), behavior: 'smooth'});
    });
    sync(dots);
  };
  const run = () => document.querySelectorAll('[data-bx-dots]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
